// extracted by mini-css-extract-plugin
export var productImage = "_zl-0";